import { render } from "./ChangeAttivo.vue?vue&type=template&id=a971dc70&scoped=true"
import script from "./ChangeAttivo.vue?vue&type=script&lang=js"
export * from "./ChangeAttivo.vue?vue&type=script&lang=js"

import "./ChangeAttivo.vue?vue&type=style&index=0&id=a971dc70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a971dc70"]])

export default __exports__